<template>
    <basic-container>
        <div class="detail_wrapper">
            <div class="con_wrapper">
                <FrameWrapper title="走访基本信息">
                    <template slot="contentSlot">
                        <div class="content_slot">
                            <a-descriptions class="label_wrapper" border :column="2">
                                <a-descriptions-item label="走访时间">{{ formatter(formData.visitDate)
                                }}</a-descriptions-item>
                                <a-descriptions-item label="走访人">{{ formatter(formData.createUserName)
                                }}</a-descriptions-item>
                                <a-descriptions-item label="随同走访人员">{{ formatter(formData.visitPeople)
                                }}</a-descriptions-item>
                                <a-descriptions-item label="联合走访单位">{{ formatter(formData.visitDept)
                                }}</a-descriptions-item>
                                <a-descriptions-item label="意见建议">{{ formatter(formData.suggestion) }}</a-descriptions-item>
                            </a-descriptions>

                        </div>
                    </template>
                </FrameWrapper>
                <FrameWrapper title="走访企业信息">
                    <template slot="contentSlot">
                        <div class="content_slot">
                            <a-descriptions class="label_wrapper" border :column="2">
                                <a-descriptions-item label="企业名称">{{ formatter(formData.visitEntName)
                                }}</a-descriptions-item>
                                <a-descriptions-item label="行业地位">{{ formatter(formData.entPosition)
                                }}</a-descriptions-item>
                                <a-descriptions-item label="年产值">{{ formatter(formData.entProdVal, "亿元")
                                }}</a-descriptions-item>
                                <a-descriptions-item label="年纳税额">{{ formatter(formData.entTaxVal, "万元")
                                }}</a-descriptions-item>
                                <a-descriptions-item label="科技含量">{{ formatter(formData.entTechVal) }}</a-descriptions-item>
                                <a-descriptions-item label="重点市场">{{ formatter(formData.entImpMarket)
                                }}</a-descriptions-item>
                                <a-descriptions-item label="对接联系人" :span="2">
                                    <div class="person_wrapper">
                                        <div v-if="formData.visitContractPerson.length > 0"
                                            v-for="(item) in formData.visitContractPerson" :key="item.id"
                                            class="person-con">
                                            <div class="person-item flex-con">
                                                <span class="person-item-title">{{ `${item.name}/${item.phone}/${item.job}`
                                                }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </a-descriptions-item>
                                <a-descriptions-item label="企业简介" :span="2">{{ formatter(formData.entIntro)
                                }}</a-descriptions-item>
                            </a-descriptions>

                        </div>
                    </template>
                </FrameWrapper>
                <FrameWrapper title="近期投资计划">
                    <template slot="contentSlot">
                        <div class="content_slot">
                            <a-descriptions class="label_wrapper" border :column="2">
                                <a-descriptions-item label="投资意向">{{ dictionaryLabel(formData.investInten,
                                        investIntenList)
                                    }}</a-descriptions-item>

                                <template v-if="formData.investInten==investIntenInfo.have">
                                    <a-descriptions-item label="项目概况">{{ formatter(formData.projectIntro)
                                    }}</a-descriptions-item>
                                    <a-descriptions-item label="项目类型">{{ dictionaryLabel(formData.projectType,
                                        dictionaryData.zsProjectTypeList)
                                    }}</a-descriptions-item>
                                    <a-descriptions-item label="投资规模">{{ formatter(formData.investVal, "亿元")
                                    }}</a-descriptions-item>
                                </template>

                            </a-descriptions>

                        </div>
                    </template>
                </FrameWrapper>
                <FrameWrapper title="辅证材料">
                    <template slot="contentSlot">
                        <div class="content_slot">
                            <div  class="el-collapse-item__content">
                                <Accessory
                                    element-loading-text="加载中"
                                    element-loading-spinner="el-icon-loading"
                                    element-loading-background="rgba(153, 153, 153, 0.8)"        
                                    :projectid="id"
                                    :dynamicId="id"
                                    fileMenuUrlname="数字化招商平台"
                                    idname="项目申报"
                                    :upload="false"
                                    />
                            </div>
                        </div>
                    </template>
                </FrameWrapper>
            </div>
        </div>
    </basic-container>
</template>
<script>
import moment from "moment"
import * as api from '@/api/zs/zs'
import util from "@/mixins/util";
import FrameWrapper from "@/components/frame/zsFrame"
import Accessory from "@/components/accessoriesother/accessoryFactor";
import ProjectInfo from "./../../components/projectInfo.vue"
import {
    validatenull
} from "@/util/validate";
export default {
    name: 'visitQueryDetail',
    mixins: [util],
    components: {
        FrameWrapper,
        ProjectInfo,
        Accessory
    },
    data() {
        return {
            tableData: [],
            id: -1,
            formData: {

            },
            dictionaryData: {

            },
            investIntenInfo:{
                have:"1",  //有
                notHave:'0' //没有
            },
            investIntenList:[
                {dictKey:"1" ,dictValue:"有"},
                {dictKey:"0" ,dictValue:"没有"},
            ]

        }
    },
    computed: {

        formatter() {
            return function (field, unit) {
                return validatenull(field) ? '/' : field + (validatenull(unit) ? '' : unit)
            }
        }
    },

    async mounted() {
        //行业地位目前没有字典
        let dataList = [
            {code: "zs_project_type", name: "zsProjectTypeList"},
        ];
        let dictionaryData = await this.dictionaryAllMap(dataList);
        this.dictionaryData = dictionaryData

        this.id = this.$route.params.id;
        this.queryDetail(this.id)
    },
    methods: {
        moment,
        async queryDetail(id) {
            const params = {id }
            const res = await api.getVisitDeclareDetail(params)
            if (res.data.code == 200) {
                const data = res.data.data
                this.formData = data
                

            }

        },
    }
}

</script>

<style lang="scss" scoped>
.person_wrapper {
    display: grid;
}

.detail_wrapper {
    // padding: 20px !important;
    background-color: #fff;

    .header_wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        line-height: 60px;
        border-bottom: 1px solid rgb(233, 233, 233);

        .header_left {
            font-weight: 700;
            font-style: normal;
            font-size: 18px;
            color: #333
        }

        .header_right {}

    }

    .con_wrapper {
        .content_slot {
            padding: 20px 1rem;
        }
    }
}

:deep(.descriptions_label) {
    background-color: #ECF5FF !important;
}

/deep/.ant-descriptions-item .ant-descriptions-item-label {
    color: #999999;
    font-weight: 400;
    text-align: right;
}

/deep/.ant-descriptions-item .ant-descriptions-item-content {
    color: #333333;
    font-weight: 400;
}
</style>
